import axios from "axios";

const user = JSON.parse(JSON.parse(localStorage.getItem("user")))
export default axios.create({
	baseURL: process.env.REACT_APP_PROD_API_URL,
	headers: {
		Authorization: `Bearer ${user ? user.token : ""}`,
		'Content-Type': 'application/json; charset=utf-8'
	}
})